import script from "./TeamView.vue?vue&type=script&setup=true&lang=ts"
export * from "./TeamView.vue?vue&type=script&setup=true&lang=ts"

import "./TeamView.vue?vue&type=style&index=0&id=0e2d3ddd&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0e2d3ddd"]])

export default __exports__